import Background from './Background'
import Templates from './Templates'
import Layers from './Layers'
import Text from './Text'
import Elements from './Elements'
import FontFamily from './FontFamily'
import Color from './Color'
import Images from './Images'
import Illustrations from './Illustrations'
import Pixabay from './Pixabay'
import Uploads from './Uploads'

class PanelItems {
  static Background = Background
  static Text = Text
  static Layers = Layers
  static Templates = Templates
  static Elements = Elements
  static FontFamily = FontFamily
  static Color = Color
  static Images = Images
  static Illustrations = Illustrations
  static Pixabay = Pixabay
  static Uploads = Uploads
}

export default PanelItems
